import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from '@parkwhiz-js/react-popover';
import ClickOutside from 'react-click-outside';

import Checkmark from 'components/svgs/icons/checkmark';
import BrandName from 'containers/common/brand-name';

const propTypes = {
  label: PropTypes.string.isRequired,
  showTooltip: PropTypes.bool,
  trackToolTipClick: PropTypes.func
};

const defaultProps = {
  showTooltip: true,
  trackToolTipClick: () => {},
};

class CuratedLabel extends Component {
  constructor(props) {
    super(props);

    this.hideTooltip = this.hideTooltip.bind(this);
  }

  renderTooltip() {
    const trigger = (
      <span className="text-color-white" onClick={this.props.trackToolTipClick}>
        <span className="uppercase">
          { this.props.label }
        </span>
        <span className="iconified-font iconified-info-circle-fill margin-left-10" />
      </span>
    );

    return (
      <ClickOutside onClickOutside={this.hideTooltip} >
        <Popover ref={(c) => { this.tooltip = c; }} position="bottom" trigger={trigger}>
          <div className="popover-message text-align-left text-size-14">
            Our best overall option for you based on price, distance, and <BrandName /> user ratings.
            <a onClick={this.hideTooltip}>
              <div className="popover-dismiss margin-top-10 text-weight-medium text-size-12">
                GOT IT
                <span className="isvg loaded">
                  <Checkmark />
                </span>
              </div>
            </a>
          </div>
        </Popover>
      </ClickOutside>
    );
  }

  showTooltip() {
    this.tooltip.setState({ isPopoverShown: true });
  }

  hideTooltip() {
    this.tooltip.setState({ isPopoverShown: false });
  }

  render() {
    const { label, showTooltip } = this.props;

    if (label.toLowerCase() === 'top pick' && showTooltip) {
      return this.renderTooltip();
    }

    return (
      <span className="uppercase" onClick={this.props.trackToolTipClick}>
        { label }
      </span>
    );
  }
}

CuratedLabel.propTypes = propTypes;
CuratedLabel.defaultProps = defaultProps;

export default CuratedLabel;

